import { render, staticRenderFns } from "./RatingIcons.vue?vue&type=template&id=130b8eeb"
import script from "./RatingIcons.js?vue&type=script&lang=js&external"
export * from "./RatingIcons.js?vue&type=script&lang=js&external"
import style0 from "./RatingIcons.vue?vue&type=style&index=0&id=130b8eeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports